import { compose } from 'ramda'
import getTargetValue from './get-target-value'

const setTargetValue = setter => compose(
  setter,
  getTargetValue
)

export default setTargetValue